import React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import LayoutRoutes from './LayoutRoutes'
import PrivateRoutes from './PrivateRoutes';
import SignIn from '../Auth';
import ResetPasswordPage from '../Auth/ResetPasswordPage';

function isLoggedIn() {
    return localStorage.getItem("login") === "true";
}

export default function Routers() {
    const login = isLoggedIn();
    const publicUrl = process.env.PUBLIC_URL;
    const basename = publicUrl && publicUrl !== '.' ? publicUrl : '/';

    return (
        <BrowserRouter basename={basename}>
            <Routes>
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route
                    path="/"
                    element={
                        <Navigate
                            to={login ? '/dashboard/default' : '/login'}
                            replace
                        />
                    }
                />
                <Route path={"/"} element={<PrivateRoutes />}>
                    <Route path={"/*"} element={<LayoutRoutes />} />
                </Route>
                <Route
                    path="/login"
                    element={login ? <Navigate to="/dashboard/default" replace /> : <SignIn />}
                />
            </Routes>
        </BrowserRouter>
    )
}
